import { gql } from 'graphql-tag';
import {
  FORM_CARD_FIELDS,
  FORM_DETAIL_FIELDS,
  FORM_SUBMISSION_COLUMN_FIELDS,
  FORM_SUBMISSION_ROW_FIELDS,
  FORM_VERSION_FIELDS,
} from './fragments';

// Canonical queries (build plan §3.3). Operation names are what
// refetchQueries refers to.

export const GET_FORMS_ADMIN = gql`
  query GetFormsAdmin($input: GetFormsAdminInput!) {
    getFormsAdmin(input: $input) {
      count
      results {
        ...FormCardFields
      }
    }
  }
  ${FORM_CARD_FIELDS}
`;

export const GET_FORMS_SUMMARY = gql`
  query GetFormsSummary($input: GetFormsSummaryInput) {
    getFormsSummary(input: $input) {
      active_count
      archived_count
      accounts {
        account_id
        name
        count
      }
    }
  }
`;

export const GET_FORM_ADMIN = gql`
  query GetFormAdmin($id: Int!) {
    getFormAdmin(id: $id) {
      ...FormDetailFields
    }
  }
  ${FORM_DETAIL_FIELDS}
`;

export const GET_FORM_NOTES = gql`
  query GetFormNotes($form_id: Int!) {
    getFormNotes(form_id: $form_id) {
      id
      body
      author_id
      author_name
      created_at
    }
  }
`;

export const GET_SAVED_FORM_FIELDS = gql`
  query GetSavedFormFields($input: GetSavedFormFieldsInput) {
    getSavedFormFields(input: $input) {
      id
      account_id
      name
      base_type
      config
      created_at
    }
  }
`;

export const GET_FORM_RECIPIENT_SUGGESTIONS = gql`
  query GetFormRecipientSuggestions($input: GetFormRecipientSuggestionsInput!) {
    getFormRecipientSuggestions(input: $input) {
      user_id
      name
      email
      role
      on_team
    }
  }
`;

export const GET_FORM_SUBMISSIONS = gql`
  query GetFormSubmissions($input: GetFormSubmissionsInput!) {
    getFormSubmissions(input: $input) {
      count
      results {
        ...FormSubmissionRowFields
      }
      columns {
        ...FormSubmissionColumnFields
      }
      versions {
        ...FormVersionFields
      }
    }
  }
  ${FORM_SUBMISSION_ROW_FIELDS}
  ${FORM_SUBMISSION_COLUMN_FIELDS}
  ${FORM_VERSION_FIELDS}
`;

export const GET_FORM_SUBMISSION = gql`
  query GetFormSubmission($id: Int!) {
    getFormSubmission(id: $id) {
      ...FormSubmissionRowFields
      version {
        ...FormVersionFields
      }
      files {
        id
        purpose
        field_id
        filename
        content_type
        size_bytes
        url
        created_at
      }
    }
  }
  ${FORM_SUBMISSION_ROW_FIELDS}
  ${FORM_VERSION_FIELDS}
`;

export const GET_FORM_SUBMISSION_STATS = gql`
  query GetFormSubmissionStats($form_id: Int!) {
    getFormSubmissionStats(form_id: $form_id) {
      total
      new_this_week
      latest_submitted_at
      latest_submitter_name
      weekly {
        week_start
        week_end
        count
      }
      weekly_total
      weekly_average
    }
  }
`;

export const GET_FORM_FILE_DOWNLOAD_URL = gql`
  query GetFormFileDownloadUrl($id: Int!) {
    getFormFileDownloadUrl(id: $id) {
      url
      filename
      expires_at
    }
  }
`;

// A signed link to a finished export's file (owner only, short-lived).
export const GET_EXPORT_RUN_DOWNLOAD_URL = gql`
  query GetExportRunDownloadUrl($id: Int!) {
    getExportRunDownloadUrl(id: $id)
  }
`;
